export enum LoaderSizes {
    Default,
    Small,
    XSmall,
}
